import { BaseApi } from './base.api.js';

export class CrisisRecoveryActivitiesApi extends BaseApi {
    constructor(client) {
        super(client, '/crisis-recovery-activities');
    }
}
